import { createContext } from 'react';

import type { TimeseriesSelectProps } from '../slots/Select.js';

export const TimeseriesChartSelectContext = createContext<
  TimeseriesSelectProps | undefined
>(undefined);
